import Rollbar from 'rollbar';

let rollbar: Rollbar | undefined;

const environment = process.env.REACT_APP_ENV ?? 'dev';
const accessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;

export const init = (id: string) => {
    if (!accessToken) {
        console.log('Could not find rollbar access token');
        return;
    }

    try {
        rollbar = new Rollbar({
            accessToken: "cfc1401c03e941aa95cc1bc350a18674", // accessToken,
            captureUncaught: false,
            captureUnhandledRejections: false,
            enabled: environment !== 'dev',
            payload: {
                environment,
                person: {
                    id
                }
            }
        });
    } catch (e) {
        console.log('Unable to create rollbar logger')
    }

}

export const setCompanyId = (id: string) => {
    rollbar?.configure({
        payload: { person: { id } }
    })
};

export const info = (type: string, data?: any) => rollbar?.info(type, data);
export const warn = (type: string, data?: any) => rollbar?.warn(type, data);
export const error = (type: string, data?: any) => rollbar?.error(type, data);
export const debug = (type: string, data?: any) => rollbar?.debug(type, data);


